import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/common/Loader";

const STAFF = ["admin", "editor", "support_manager"];

export const ProtectedRoute = ({ children, requireAdmin = false, requireStaff = false, requireRoles = null }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/" replace />;
  if (requireStaff && !STAFF.includes(user.role)) return <Navigate to="/portal" replace />;
  if (Array.isArray(requireRoles) && !requireRoles.includes(user.role)) return <Navigate to="/admin" replace />;
  return children;
};
